export const GTM_DEVICE_CHANNEL_MOWEB = 'MOWEB';

export const GTM_DEVICE_CHANNEL_MOAPP = 'MOAPP';

export const GTM_CSTT = 'gtm-cstt'; // 상담신청, 언택트 상담신청 화면이 노출되었을 때(quick-conulst 페이지, 팝업)

export const GTM_CSTC = 'gtm-cstc'; // 상담신청, 언택트 상담신청이 완료되었을 때 (성공)

export const GTM_CTA_REMO_EVENT_NAME = 'cta-remo-event'; // 리모델링  dataLayer 이벤트 네임

export const GTM_REMO_EVENT_NAME = 'gtm_remo_event';

export const GTM_KEY_NAME = 'gtmKeyword'; // gtm key

export const GTM_CTA_KEY_NAME = 'ctaKeyword'; // gtm cta key

// 언택트
export const GTM_UNTACT_FPNOTFOUND = 'untact_fpnotfound'; // 도면없는주소 popup

export const GTM_UNTACT_FPNOTFOUND_CONFIRM = 'untact_fpnotfound_confirm'; // 도면없는주소 popup - 상담신청 전환 확인 btn

export const GTM_UNTACT_TYPENOTFOUND = 'untact_typenotfound'; // 도면없는타입 빠른전환 btn

export const GTM_UNTACT_TYPENOTFOUND_CONFIRM = 'untact_typenotfound_confirm'; // 도면없는타입 상담신청전환 확인 btn

export const GTM_UNTACT_QCTRANSFER = 'untact_QCtransfer'; // 언택트 상세 상담신청 전환

export const GTM_UNTACT_BASICINFO_EXIT = 'untact_basicinfo_exit'; // 언택트popup 기본정보

export const GTM_UNTACT_PLAN_SCOPE_EXIT = 'untact_plan_scope_exit'; // 언택트popup 공사범위

export const GTM_UNTACT_PLAN_DAY_EXIT = 'untact_plan_day_exit'; // 언택트popup 공사희망일

export const GTM_UNTACT_PLAN_STATUS_EXIT = 'untact_plan_status_exit'; // 언택트popup 공간상태

export const GTM_UNTACT_PLAN_STYLE_EXIT = 'untact_plan_style_exit'; // 언택트popup 선호스타일

export const GTM_UNTACT_PLAN_GRADE_EXIT = 'untact_plan_grade_exit'; // 언택트popup 그레이드

export const GTM_UNTACT_PLAN_SCRAP_EXIT = 'untact_plan_scrap_exit'; // 언택트popup 스크랩

export const GTM_UNTACT_BASE_EXPANSION_EXIT = 'untact_base_expansion_exit'; // 언택트popup 확장

export const GTM_UNTACT_BASE_MOLDING_EXIT = 'untact_base_molding_exit'; // 언택트popup 목공몰딩

export const GTM_UNTACT_BASE_CARPENTCEILING_EXIT =
  'untact_base_carpentceiling_exit'; // 언택트popup 목공천장

export const GTM_UNTACT_BASE_CARPENTWALL_EXIT = 'untact_base_carpentwall_exit'; // 언택트popup 목공벽

export const GTM_UNTACT_BASE_TILE_EXIT = 'untact_base_tile_exit'; // 언택트popup 타일

export const GTM_UNTACT_BASE_FILM_EXIT = 'untact_base_film_exit'; // 언택트popup 필름

export const GTM_UNTACT_BASE_PAINT_EXIT = 'untact_base_paint_exit'; // 언택트popup 도장

export const GTM_UNTACT_BASE_WALLPAPER_EXIT = 'untact_base_wallpaper_exit'; // 언택트popup 도배

export const GTM_UNTACT_BASE_ETC_EXIT = 'untact_base_etc_exit'; // 언택트popup 기타;

export const GTM_UNTACT_STYLE_WINDOW_EXIT = 'untact_style_window_exit'; // 언택트popup 창호

export const GTM_UNTACT_STYLE_DOOR_EXIT = 'untact_style_door_exit'; // 언택트popup 도어

export const GTM_UNTACT_STYLE_CETRALDOOR_EXIT = 'untact_style_cetraldoor_exit'; // 언택트popup 중문

export const GTM_UNTACT_STYLE_BATH_EXIT = 'untact_style_bath_exit'; // 언택트popup 욕실

export const GTM_UNTACT_STYLE_FLOOR_EXIT = 'untact_style_floor_exit'; // 언택트popup 바닥

export const GTM_UNTACT_STYLE_KITCHEN_EXIT = 'untact_style_kitchen_exit'; // 언택트popup 부엌

export const GTM_UNTACT_STYLE_STORAGE_EXIT = 'untact_style_storage_exit'; // 언택트popup 수납

export const GTM_UNTACT_STYLE_WALLSTYLE_EXIT = 'untact_style_wallstyle_exit'; // 언택트popup 벽스타일

export const GTM_UNTACT_STYLE_LIGHTING_EXIT = 'untact_style_lighting_exit'; // 언택트popup 조명

export const GTM_UNTACT_STYLE_COMMENT_EXIT = 'untact_style_comment_exit'; // 언택트popup 남기고싶은말

// 매장
export const GTM_VISIT_RESERVE_FIN = 'visit_reserv_fin';

export const GTM_CST_KEYWORD = 'cstKeyword'; // 시도할 때마다 다르게

export const GTM_VISIT_CONSULT_KEYWORD = 'visit'; // 매장 방문 상담시도, 완료시

export const GTM_QUICK_CONSULT_KEYWORD = 'quick'; // 상담시도, 완료시

export const GTM_UNTACT_CONSULT_KEYWORD = 'untact'; // 언텍트 상담 상담시도, 완료시

// 상담신청
export const GTM_SEQ_CONSULT_KEYWORD = 'seq'; // 시퀀셜 상담

export const GTM_MATCH_CONSULT_KEYWORD = 'match'; // ai Match 상담

export const GTM_SEQ_CONSULT_VIEW_KEYNAME = 'seq_view_consult'; // 시퀀셜 상담신청 진입시

export const GTM_MATCH_CONSULT_VIEW_KEYNAME = 'match_view_consult'; // ai Match 상담신청 진입시

export const GTM_SEQ_CONSULT_KEYNAME = 'seq_submit_consult'; // 시퀀셜 상담신청 완료시

export const GTM_MATCH_CONSULT_KEYNAME = 'match_submit_consult'; // ai Match 상담신청 완료시
